<template>
  <layout-default-app-bar :back-to="true">
    Coleta
  </layout-default-app-bar>
</template>

<script>

// import { IMAGENS_QUERIES } from '@/constants/QUERY_FILTERS';

import {
  ROUTE_COLETA_CADASTRO,
} from '@/constants/ROUTES';

import LayoutDefaultAppBar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewHomeAppBar',

  components: {
    LayoutDefaultAppBar,
  },


  data() {
    return {
      backTo: ROUTE_COLETA_CADASTRO
    };
  },

};
</script>

<style scoped>
  #icone{
    top: 6%;
    position: relative;
  }

  #texto {
    position: absolute;
    left: 120px;
    bottom: 8px;
    font-size: 24px;
  }
</style>
